var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('div',{class:_vm.classesRoot},[_c('ProgressCircular',{attrs:{"indeterminate":true,"size":"72","width":"6","color":"#fff"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }